// extracted by mini-css-extract-plugin
export default {"imgBg":"Torcher_imgBg__-zGEj","nickName":"Torcher_nickName__8pkVt","no":"Torcher_no__Q5yj4","back":"Torcher_back__oG0Cy"};